export function schema_user_details() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_client_user_uid: {
				title: "Colonne des utilisateurs - uid ou idenntifiant en fonction de l'action choisie",
				type: "string"
			},
			column_details: {
				type: "string",
				title: "Colonne du json des éléments de profil",
			},
			action: {
				title: "action",
				type: "string",
				enum: ["Récupérer", "Récupérer (identifiant)", "Enregistrer", "Liste"]
			},
		},
	};
}
